"use client";
const title = 'Clinical Information | CRENESSITY® (crinecerfont) HCP';
const description = 'Explore the results for CRENESSITY® from the largest-ever clinical trial for the treatment of classic congenital adrenal hyperplasia (CAH). See full Prescribing and Safety Information.';
export const meta = {
  title,
  footer: {
    code: <>CP-CFT-US-0263v5</>,
    codeDate: <>08/2026</>,
    codeYear: <>2026</>,
  },
  metadata: [
    {
      name: 'description',
      content: description,
    }, {
      name: 'twitter:title',
      content: title,
    }, {
      name: 'twitter:description',
      content: description,
    }, {
      property: 'og:title',
      content: title,
    }, {
      property: 'og:description',
      content: description
    }, {
      property: 'og:url',
      content: 'https://www.crenessityhcp.com/clinical-information',
    }, {
      property: 'og:site_name',
      content: 'CRENESSITY® (crinecerfont) HCP Website'
    }, {
      property: 'og:type',
      content: 'website',
    }, {
      property: 'og:image',
      content: 'https://www.crenessityhcp.com/images/og/MOA_Hero-Image.png',
    }, 
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://www.crenessityhcp.com/clinical-information',
    }, {
      rel: 'alternate',
      hrefLang: 'en-us',
      href: 'https://www.crenessityhcp.com/clinical-information',
    },
  ],
  schemaTag: [
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "MedicalWebPage",
          "@id": "https://www.crenessityhcp.com/clinical-information#webpage",
          "url": "https://www.crenessityhcp.com/clinical-information",
          "name": "Clinical Information | CRENESSITY® (crinecerfont) HCP",
          "description": "Explore the results for CRENESSITY® from the largest-ever clinical trial for the treatment of classic congenital adrenal hyperplasia (CAH). See full Prescribing and Safety Information.",
          "isPartOf": {
            "@type": "WebSite",
            "name": "CRENESSITY HCP",
            "url": "https://www.crenessityhcp.com"
          },
          "dateModified": "2025-09-15",
          "audience": { "@type": "MedicalAudience", "audienceType": "HealthcareProvider" },
          "about": [
            { "@type": "MedicalCondition", "name": "Classic congenital adrenal hyperplasia (CAH)", "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/" },
            { "@type": "Drug", "name": "crinecerfont", "alternateName": ["Crenessity", "Crenessity crinecerfont"], "sameAs": "https://go.drugbank.com/drugs/DB18518" }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.crenessityhcp.com" },
            { "@type": "ListItem", "position": 2, "name": "Clinical Information", "item": "https://www.crenessityhcp.com/clinical-information" }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.neurocrine.com/#org",
          "name": "Neurocrine Biosciences, Inc.",
          "url": "https://www.neurocrine.com/"
        }
      ]
    }
  ]
};